import axios from 'axios';
import {
  GET_FIXTURES_REQUEST,
  GET_FIXTURES_SUCCESS,
  GET_FIXTURES_FAILURE
} from 'Store/constants';
import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;
export const getFixtures = options => async dispatch => {

  let week = options.requestedWeek.replace(' ', '%20');

  try {
    dispatch({
      type: GET_FIXTURES_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/${options.eventId}/fixture?requestedSeason=${options.requestedSeasonName}&requestedWeek=${week}`);

    dispatch({
      type: GET_FIXTURES_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_FIXTURES_FAILURE,
      payload: errorMessage
    });
  }
};
